import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/:productId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/:productId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/:productId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/products/:productId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}